// extracted by mini-css-extract-plugin
export default {"badge":"Badge-index__badge--ZoH2H"};